import React, {useEffect, useState} from 'react'

import useStreamStore from '../stores/StreamStore';
import useUserSettingStore from '../stores/UserSettingsStore';
import useUserStore from '../stores/UserStore';
import useSettingsStore from '../stores/SettingsStore';
import useExchangeStore from '../stores/ExchangesStore';
import useConsoleStore from '../stores/ConsoleStore';
import useTradeStore from '../stores/TradesStore';
import useAlgoStore from '../stores/AlgosStore';
import useTriggerStore from '../stores/TriggersStore';
import useArbStore from '../stores/ArbsStore';
import usePositionsStore from '../stores/PositionsStore';

function Sockets() {

  const [socket, setSocket] = useState(null)
  const [retryTimeout, setRetryTimeout] = useState(null);
  const [heartbeatTimeout, setHeartbeatTimeout] = useState(null);
  const [pongTimeout, setPongTimeout] = useState(null);

  const updateCandles = useStreamStore(state => state.updateCandles);
  const updateOrderBook = useStreamStore(state => state.updateOrderBook);

  const userID = useUserStore((state) => state.userID)

  const setDefaultUserSetting = useUserSettingStore((state) => state.setDefaultUserSetting)
  const reloadUserSettings = useUserSettingStore((state) => state.reloadUserSettings)

  const reload_settings = useSettingsStore((state) => state.reloadSettings)
  const setDefaultSelected = useSettingsStore((state) => state.setDefaultSelected)

  const add_output = useConsoleStore((state) => state.addOutput)

  const addTrade = useTradeStore((state) => state.addTrade)
  const updateTrade = useTradeStore((state) => state.updateTrade)
  const removeTrade = useTradeStore((state) => state.removeTrade)

  const addAlgo = useAlgoStore((state) => state.addAlgo)
  const updateAlgo = useAlgoStore((state) => state.updateAlgo)
  const removeAlgo = useAlgoStore((state) => state.removeAlgo)

  const addTrigger = useTriggerStore((state) => state.addTrigger)
  const updateTrigger = useTriggerStore((state) => state.updateTrigger)
  const removeTrigger = useTriggerStore((state) => state.removeTrigger)

  const add_exchange = useExchangeStore((state) => state.add_exchange)
  const remove_exchange = useExchangeStore((state) => state.remove_exchange)

  const updatePosition = usePositionsStore((state) => state.updatePosition)
  const removePosition = usePositionsStore((state) => state.removePosition)
  const addPosition = usePositionsStore((state) => state.addPosition)


  const addArb = useArbStore((state) => state.addArb)
  const updateArb = useArbStore((state) => state.updateArb)
  const removeArb = useArbStore((state) => state.removeArb)
  const updateBalance = useArbStore((state) => state.updateBalance)
  const updatePNL = useArbStore((state) => state.updatePNL)




  useEffect(() => {
    const sendHeartbeat = () => {
      if (!socket) return;
      if (socket.readyState !== 1) return;
    };


    const connectSocket = () => {
      const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'ws://localhost:8000/ws';
      const socket = new WebSocket(SOCKET_URL);
      
  
      setSocket(socket);
      socket.onopen = () => {
        console.log('ON OPEN')
        // const interval = setInterval(() => {
        //   sendHeartbeat()
        // }, 60000)
        // return () => clearInterval(interval);
        return
      };

      socket.onclose = (event) => {
        setTimeout(connectSocket, 5000)
      };
      
    // socket.onmessage = (message) => {
    //     const data = JSON.parse(message.data);
    //     // console.log('MESSAGE', data)
  
    //     if (data.type === 'candles') {
    //       updateCandles(data);
    //     } else if (data.type === 'orderBook') {
    //       updateOrderBook(data);
    //     }
    //   };
      socket.onmessage = (event) => {

        const jsonData = JSON.parse(event.data);
        const topic = jsonData.channel; 
        const data = jsonData.update
        console.log('Message', data)
    
    switch (topic) {            
      case userID+'@'+'userSettingUpdate':
        reloadUserSettings(data);
        if (data.update === "delete") {
          setDefaultUserSetting();
        }
        break;

      case userID+'@'+'settingUpdate':
        reload_settings(data);
        if (data.update === "delete") {
          setDefaultSelected();
        }
        break;

      case userID+'@'+'consoleNew':
        add_output(data);
        break;

      case userID+'@'+'exchangeNew':
        add_exchange(data);
        break;

      case userID+'@'+'exchangeExited':
        remove_exchange(data.exchange_name);
        break;
      
      case userID+'@'+'positionUpdate':
        updatePosition(data.item);
        break;
      case userID+'@'+'positionNew':
        addPosition(data.item);
        break;
      case userID+'@'+'positionExited':
        removePosition(data.item);
        break;
        
      case userID+'@'+'tradeUpdate':
        updateTrade(data.item);
        break;

      case userID+'@'+'tradeNew':
        addTrade(data.item);
        break;

      case userID+'@'+'tradeExited':
        removeTrade(data.item);
        break;

      case userID+'@'+'algoUpdate':
        updateAlgo(data.item);
        break;

      case userID+'@'+'algoNew':
        addAlgo(data.item);
        break;

      case userID+'@'+'algoExited':
        removeAlgo(data.item);
        break;

      case userID+'@'+'triggerUpdate':
       
        updateTrigger(data);
        break;

      case userID+'@'+'triggerNew':
        console.log('UPODATE new', data)
        addTrigger(data);
        break;

      case userID+'@'+'triggerExited':
        console.log('UPODATE remove', data)
        removeTrigger(data);
        break;

      case userID+'@'+'arbUpdate':
        updateArb(data.item);
        break;

      case userID+'@'+'arbNew':
        addArb(data.item);
        break;

      case userID+'@'+'arbExited':
        removeArb(data.item);
        break;

      case userID+'@'+'balanceUpdate':
        updateBalance(data);
        break;

      case userID+'@'+'updatePNL':
        updatePNL(data.pnl);
        break;
    }

    };
 
      };
    
    connectSocket();
    return () => {
      if (socket) socket.close();
      if (retryTimeout) clearTimeout(retryTimeout);
      if (heartbeatTimeout) clearTimeout(heartbeatTimeout);
      if (pongTimeout) clearTimeout(pongTimeout);
    };
  }, [])
           
  return null
}

export default Sockets


